/**
 * Toast Helper
 * Centralized helper for showing toast notifications throughout the application
 */

/**
 * Show a toast notification
 * @param {Object} store - Vuex store instance
 * @param {string} title - Toast title
 * @param {string} message - Toast message
 * @param {string} variant - Toast variant: 'info', 'success', 'warning', 'danger'
 */
export function showToast(store, title, message, variant = "info") {
  store.dispatch("app/showToast", { title, message, variant });
}

/**
 * Hide the current toast notification
 * @param {Object} store - Vuex store instance
 */
export function hideToast(store) {
  store.dispatch("app/hideToast");
}

export default {
  showToast,
  hideToast
};
